/**
 * useSession - Simple wrapper around useAuth for session access
 */
import { useAuth } from "@/contexts/AuthContext";
import type { Session } from "@supabase/supabase-js";

export interface UseSessionResult {
  session: Session | null;
  loading: boolean;
}

export function useSession(): UseSessionResult {
  const { session, loading } = useAuth();
  return { session, loading };
}
